import { render, staticRenderFns } from "./DimensionSummary.vue?vue&type=template&id=b1d416de"
import script from "./DimensionSummary.vue?vue&type=script&lang=js"
export * from "./DimensionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports